import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-contactpersonenlist',
  templateUrl: './contactpersonenlist.component.html',
  styleUrls: ['./contactpersonenlist.component.less']
})
export class ContactpersonenlistComponent implements OnInit {


  @Input() relatieid : number;
  contactpersonen : any = null;

  constructor(private source: RelatiesService,private router: Router) { }

  ngOnInit() {
    this.source.getContactpersonen(this.relatieid).subscribe(data => {
      this.contactpersonen = data;
    })
  }

  addNew() {
    this.router.navigateByUrl('/contactpersoontoevoegen/' + this.relatieid)
  }

  deleted(id: number) {
    this.contactpersonen.forEach( (item, index) => {
        if(item.ID === id) {
          this.contactpersonen.splice(index,1);
        }
    });
  }

}
